module.exports = __webpack_public_path__ + "img/chaxun.8bb74cd1.jpg";